// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"2324": "25e50ce7","4342": "e5b33855","4777": "13f44d2c","4846": "d8530b68","5213": "9eba3fd9","5501": "2a5f2a80","6981": "462434b6","9437": "e84ea252",}[chunkId] + ".css"
}